"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoftwareLicenseAddNewModalButton = SoftwareLicenseAddNewModalButton;
exports.SoftwareLicenseEditModalButton = SoftwareLicenseEditModalButton;
exports.LicenseForm = LicenseForm;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_hook_form_1 = require("react-hook-form");
const yup_1 = require("@hookform/resolvers/yup");
const CommonComponents_1 = require("../../../View/Resultsets/CommonComponents");
const SoftwareLicensesController_1 = require("../SoftwareLicensesController");
const SoftwareLicenseValidationSchema_1 = require("./SoftwareLicenseValidationSchema");
function SoftwareLicenseAddNewModalButton({ modalProps: { onAddNew } }) {
    const [open, setOpen] = (0, react_1.useState)(false);
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-success", onClick: () => setOpen(true) }, "Dodaj licencj\u0119"),
        open && react_1.default.createElement(LicenseForm, { onSave: onAddNew, onClose: () => setOpen(false) }));
}
function SoftwareLicenseEditModalButton({ modalProps: { initialData, onEdit } }) {
    const [open, setOpen] = (0, react_1.useState)(false);
    return react_1.default.createElement("div", { onClick: event => event.stopPropagation() },
        react_1.default.createElement(CommonComponents_1.EditIconButton, { layout: "vertical", onClick: () => setOpen(true) }),
        open && react_1.default.createElement(LicenseForm, { initialData: initialData, onSave: onEdit, onClose: () => setOpen(false) }));
}
// GeneralModal enriches cached records with form fields; license keys must never take that path.
function LicenseForm({ initialData, onSave, onClose }) {
    const [pending, setPending] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)("");
    const defaults = Object.fromEntries(SoftwareLicenseValidationSchema_1.licenseTextFields.map(([name]) => [name, initialData?.[name] ?? ""]));
    Object.assign(defaults, {
        licenseType: initialData?.licenseType ?? "", seatsPurchased: String(initialData?.seatsPurchased ?? 1),
        seatsUsed: String(initialData?.seatsUsed ?? 0), purchaseDate: initialData?.purchaseDate ?? "",
        expirationDate: initialData?.expirationDate ?? "", cost: initialData?.cost ?? "",
        keyAction: "keep", licenseKey: "",
    });
    const { register, handleSubmit, watch, setValue, resetField, formState: { errors } } = (0, react_hook_form_1.useForm)({
        defaultValues: defaults, resolver: (0, yup_1.yupResolver)((0, SoftwareLicenseValidationSchema_1.makeSoftwareLicenseValidationSchema)()),
    });
    const keyAction = watch("keyAction");
    const free = Number(watch("seatsPurchased")) - Number(watch("seatsUsed"));
    const feedback = (name) => react_1.default.createElement(react_bootstrap_1.Form.Control.Feedback, { type: "invalid" }, errors[name]?.message);
    const input = (name, label, type = "text", limit) => react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: 6, controlId: `lic-${name}`, className: "mb-3", key: name },
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, label),
        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: type, maxLength: limit, isInvalid: !!errors[name], ...register(name) }),
        feedback(name));
    async function save(values) {
        setPending(true);
        setError("");
        const { keyAction: action, licenseKey, ...fields } = values;
        const payload = { ...fields };
        if (action === "replace")
            payload.licenseKey = licenseKey;
        if (action === "remove")
            payload.licenseKey = null;
        resetField("licenseKey");
        try {
            const saved = await SoftwareLicensesController_1.softwareLicensesRepository.saveLicense(payload, initialData?.id);
            delete payload.licenseKey;
            if (onSave)
                await onSave(saved);
            onClose();
        }
        catch {
            setError("Nie można zapisać licencji. Sprawdź połączenie i uprawnienia. Przed ponowieniem odśwież listę; klucz wpisz ponownie.");
        }
        finally {
            delete payload.licenseKey;
            setPending(false);
        }
    }
    return react_1.default.createElement(react_bootstrap_1.Modal, { show: true, size: "lg", onHide: () => { if (!pending)
            onClose(); }, backdrop: pending ? "static" : true, keyboard: !pending },
        react_1.default.createElement(react_bootstrap_1.Form, { onSubmit: handleSubmit(save), autoComplete: "off", noValidate: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: !pending },
                react_1.default.createElement(react_bootstrap_1.Modal.Title, null, initialData ? "Edycja licencji" : "Dodaj licencję")),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                react_1.default.createElement("fieldset", { disabled: pending },
                    react_1.default.createElement(react_bootstrap_1.Row, null,
                        SoftwareLicenseValidationSchema_1.licenseTextFields.slice(0, 3).map(([name, label, limit]) => input(name, label, "text", limit)),
                        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: 6, controlId: "lic-licenseType", className: "mb-3" },
                            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Typ licencji"),
                            react_1.default.createElement(react_bootstrap_1.Form.Select, { ...register("licenseType") },
                                react_1.default.createElement("option", { value: "" }, "Nie podano"),
                                react_1.default.createElement("option", null, "OEM"),
                                react_1.default.createElement("option", null, "Retail"),
                                react_1.default.createElement("option", null, "Volume"),
                                react_1.default.createElement("option", { value: "Subscription" }, "Subskrypcja")))),
                    react_1.default.createElement("h6", null, "Stanowiska"),
                    react_1.default.createElement(react_bootstrap_1.Row, null,
                        input("seatsPurchased", "Kupione", "number"),
                        input("seatsUsed", "Zajęte", "number")),
                    react_1.default.createElement("p", null,
                        "Wolne stanowiska: ",
                        Number.isInteger(free) && free >= 0 ? free : "—"),
                    react_1.default.createElement(react_bootstrap_1.Row, null, SoftwareLicenseValidationSchema_1.licenseTextFields.slice(3, 7).map(([name, label, limit]) => input(name, label, "text", limit))),
                    react_1.default.createElement("h6", null, "Zakup i rozliczenie"),
                    react_1.default.createElement(react_bootstrap_1.Row, null,
                        input("purchaseDate", "Data zakupu", "date"),
                        input("expirationDate", "Data wygaśnięcia", "date"),
                        input("cost", "Koszt brutto [zł]"),
                        input("billingCycle", "Cykl rozliczeniowy", "text", 100),
                        input("status", "Status", "text", 100)),
                    react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "lic-comment", className: "mb-3" },
                        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Uwagi"),
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 2, isInvalid: !!errors.comment, ...register("comment") }),
                        feedback("comment")),
                    react_1.default.createElement("h6", null, "Klucz licencyjny"),
                    react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "lic-keyAction", className: "mb-3" },
                        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Zmiana klucza"),
                        react_1.default.createElement(react_bootstrap_1.Form.Select, { ...register("keyAction"), onChange: event => { setValue("keyAction", event.target.value); resetField("licenseKey"); } },
                            react_1.default.createElement("option", { value: "keep" }, initialData ? "Pozostaw obecny klucz" : "Bez klucza"),
                            react_1.default.createElement("option", { value: "replace" }, "Wpisz nowy klucz"),
                            initialData?.hasLicenseKey && react_1.default.createElement("option", { value: "remove" }, "Usu\u0144 zapisany klucz")),
                        react_1.default.createElement(react_bootstrap_1.Form.Text, null, initialData?.hasLicenseKey ? "Klucz jest zapisany i pozostaje zasłonięty." : "Brak zapisanego klucza.")),
                    keyAction === "replace" && react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "lic-licenseKey" },
                        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Nowy klucz"),
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 2, style: { WebkitTextSecurity: "disc" }, autoComplete: "off", spellCheck: false, isInvalid: !!errors.licenseKey, ...register("licenseKey") }),
                        feedback("licenseKey")),
                    keyAction === "remove" && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning" }, "Zapisanie usunie klucz z tej licencji.")),
                error && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", className: "mt-3" }, error)),
            react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", disabled: pending, onClick: onClose }, "Anuluj"),
                react_1.default.createElement(react_bootstrap_1.Button, { type: "submit", disabled: pending }, pending ? "Zapisywanie…" : "Zapisz"))));
}
